import * as React from "react";

import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";

interface IProps {
  trackAndTrace: boolean;
  orderNumber: string;
}

class ShipmentDeadlineException extends React.Component<
  WithTranslation & IProps
> {
  public render() {
    const { t, trackAndTrace } = this.props;
    const baseI18nKey = `trackTrace:errors.shippingDeadlineExceeded${
      trackAndTrace ? "With" : "Without"
    }TrackAndTrace`;

    return (
      <Callout icon="error" intent="warning" title={t(`${baseI18nKey}.title`)}>
        <div>
          <Trans i18nKey={`${baseI18nKey}.description`}>
            Er lijkt iets verkeerd te zijn gegaan bij het leveren van je
            bestelling.{" "}
          </Trans>
        </div>
      </Callout>
    );
  }
}

export default withTranslation("track_trace")(ShipmentDeadlineException);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/ShipmentDeadlineException.tsx